import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import Careteam from '../../containers/Careteam/Careteam';
import PersonalContacts from '../../containers/PersonalContacts/PersonalContacts';
import AppointmentsWidget from '../../containers/Appointments/AppointmentsWidget';
import HealthSummaryDashboardPanel from '../../containers/HealthSummary/HealthSummaryDashboardPanel';
import { messages } from './Dashboard.i18n';
import Header from '../../components/Header/Header';

class Dashboard extends React.Component {
  renderTitle() {
    let arDescription = null;
    if (this.props.isAuthorizedRepresentative) {
      arDescription = (
        <FormattedMessage { ...messages.page.titleDescription}
          values={
            {
              patientFirstName: this.props.patientFirstName,
              patientLastName: this.props.patientLastName,
            }
}
        />
      );
    }
    return (
      <Header headerClassName="mb-3"
        headerTitle={
          <FormattedMessage { ...messages.page.title }
            values={{ firstName: this.props.userFirstName }}
          />
        }
        titleDescription={ arDescription }
      />
    );
  }


  render() {
    const { capabilities } = this.props;

    let appointmentField = null;
    let healthSummaryField = null;
    let careTeamField = null;
    let personalContactField = null;

    const dashboard = capabilities.find((cap) => cap.moduleName === 'Dashboard');
    const contactUs = capabilities.find((cap) => cap.moduleName === 'ContactUs');

    if (dashboard !== undefined) {
      appointmentField = dashboard.details.find((x) => x.fieldName === 'Appointments');
      healthSummaryField = dashboard.details.find((x) => x.fieldName === 'HealthSummary');
      careTeamField = dashboard.details.find((x) => x.fieldName === 'CareTeam');
      personalContactField = dashboard.details.find((x) => x.fieldName === 'PersonalContacts');
    }

    return (
      <div>
        {this.renderTitle()}
        <div className="row mb-3">
          { appointmentField ?
            <AppointmentsWidget
              capabilitySetting={appointmentField}
              contactUs={contactUs}
            /> : null }
          { healthSummaryField ? <HealthSummaryDashboardPanel /> : null }
        </div>
        { careTeamField ? <Careteam /> : null }
        { personalContactField ?
          <PersonalContacts
            capabilitySetting={personalContactField}
          /> : null }
      </div>
    );
  }
}

Dashboard.propTypes = {
  userFirstName: PropTypes.string,
  patientFirstName: PropTypes.string,
  patientLastName: PropTypes.string,
  isAuthorizedRepresentative: PropTypes.bool,
  capabilities: PropTypes.array,
};

const mapStateToProps = (state) => ({
  userFirstName: state.profile.user.firstName,
  patientFirstName: state.profile.patient.firstName,
  patientLastName: state.profile.patient.lastName,
  isAuthorizedRepresentative: state.profile.user.isAuthorizedRepresentative,
  capabilities: state.capability.capabilities,
});

export default connect(mapStateToProps)(injectIntl(Dashboard));
